import { useSelector } from 'hooks/useSelector';
import { theme } from 'lib/theme';
import * as React from 'react';
import { ScrollView, View } from 'react-native';
import { useDispatch } from 'react-redux';
import { doReportingMergeDraftFilterValues } from 'store/actions';
import {
  selectRptReportVisuals,
  selectRptReportVisualsSize,
} from 'store/remote/selectors';
import { ReportVisualKeyEnum } from 'types/Reports';
import { SeparatorHorizontal } from 'components/SeparatorHorizontal';
import { useDraggableScroll } from 'hooks/useDraggableScroll';
import { ReportingVisualsSizeEnum } from 'types/types';
import { PieChart } from '../../../../components/Visuals/PieChart';

export const Visuals: React.FC<{ reportKey: string }> = ({ reportKey }) => {
  const dispatch = useDispatch();
  const visualsSize = useSelector(selectRptReportVisualsSize);
  const reportVisuals = useSelector((state) =>
    selectRptReportVisuals(state, reportKey),
  );
  const { refs } = useDraggableScroll<ScrollView>({
    cursor: 'grab',
  });
  const finalReportVisuals = React.useMemo(
    () => reportVisuals.filter((visual) => !!ReportVisualKeyEnum[visual.type]),
    [reportVisuals],
  );
  if (!finalReportVisuals.length) {
    return null;
  }
  if (visualsSize === ReportingVisualsSizeEnum.none) {
    return null;
  }
  return (
    <>
      <View>
        <ScrollView
          ref={refs}
          disableScrollViewPanResponder
          contentContainerStyle={{
            padding: theme.padding,
            columnGap: theme.padding,
            flexDirection: 'row',
          }}
          horizontal
        >
          {finalReportVisuals.map((visual) =>
            visual.type === ReportVisualKeyEnum.checkOverallStatusPie ? (
              <PieChart
                size={
                  visualsSize === ReportingVisualsSizeEnum.small ? 150 : 250
                }
                key={visual.type}
                title={visual.config.title}
                data={visual.config.data}
                onShowInGrid={(datum) =>
                  dispatch(
                    doReportingMergeDraftFilterValues({
                      key: reportKey,
                      filterValues: { statuses: [datum.key] },
                      loadData: true,
                    }),
                  )
                }
              />
            ) : null,
          )}
        </ScrollView>
      </View>
      <SeparatorHorizontal />
    </>
  );
};
